import { useRef, useCallback, useLayoutEffect } from 'react';

/**
 * A hook that persists the reference to a callback function,
 * ensuring that the function's identity won't change across renders
 * but will always use the latest callback implementation
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useEventCallback<T extends (...args: any[]) => any>(
  callback: T
): T {
  const ref = useRef<T>(callback);

  useLayoutEffect(() => {
    ref.current = callback;
  });

  return useCallback((...args: Parameters<T>): ReturnType<T> => {
    return ref.current(...args);
  }, []) as T;
}
